<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <v-data-table
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-select="singleSelect"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="storeName"
          show-expand
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>橫幅列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <!--<v-switch
                    v-model="singleExpand"
                    label="Single expand"
                    class="pa-3"
                  ></v-switch>
                  <v-switch
                    v-model="singleSelect"
                    label="Single select"
                    class="pa-3"
                  ></v-switch>-->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <!--<v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>-->
                  <v-card-text class="pt-6">
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-img
                              :lazy-src="
                                template.photoUrl
                                  ? template.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                template.photoUrl
                                  ? template.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-row>
                              <v-col cols="8" md="8">
                                <v-text-field
                                  v-model="template.storeName"
                                  label="*商店名稱"
                                  hide-details="true"
                                  dense
                                  outlined
                                  required
                                  :rules="[(v) => !!v]"
                                ></v-text-field
                              ></v-col>
                              <v-col cols="4" md="4">
                                <v-checkbox
                                  v-model="template.shouldDisplay"
                                  label="啟用"
                                  class="mt-1"
                                  hide-details="true"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="template.photoUrl"
                                  label="圖片網址"
                                  hide-details="true"
                                  dense
                                  outlined
                                  required
                                ></v-text-field
                              ></v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="photoFile"
                                  label="不經裁切壓縮直接上傳圖片"
                                  @change="onFileChange"
                                  hide-details="true"
                                  outlined
                                  dense
                                  accept="image/png, image/jpeg, image/bmp"
                                ></v-file-input
                              ></v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="template.linkUrl"
                                  label="鏈接網址"
                                  hide-details="true"
                                  dense
                                  outlined
                                  required
                                ></v-text-field
                              ></v-col>
                              <v-col cols="12">
                                <v-btn
                                  depressed
                                  color="orange lighten-1"
                                  class="white--text"
                                  @click="showUploadImg"
                                >
                                  上傳圖片
                                </v-btn>
                                <v-btn
                                  depressed
                                  color="grey"
                                  class="ml-2 white--text"
                                  @click="template.photoUrl = ''"
                                >
                                  清除圖片
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      取消
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">確定要移除此項目?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.shouldDisplay`]="{ item }">
            <v-simple-checkbox
              class="ml-3"
              v-model="item.shouldDisplay"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>
          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-img
                              style="
                                filter: grayscale(0.8);
                                width: 98%;
                                max-width: 1000px;
                              "
                              :lazy-src="
                                item.photoUrl
                                  ? item.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                item.photoUrl
                                  ? item.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <div>
                              <div
                                class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                              >
                                狀態 -
                                {{ item.shouldDisplay ? "啟用中" : "已停用" }}
                              </div>
                              <p
                                class="text-h4 font-weight-black text--primary mb-1"
                              >
                                {{ item.storeName }}
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="1"></v-col
    ></v-row>
    <v-dialog v-model="dialog_showUploadImg" width="1580">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>上傳圖片</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_showUploadImg = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <cropperDialogs
        @update="getImgFile"
        :cropRatio="[16, 9]"
        :cropWidth="1440"
        v-if="dialog_showUploadImg"
      ></cropperDialogs>
    </v-dialog>
  </v-container>
</template>

<script>
import cropperDialogs from "@/components/cropperDialogs.vue";
import { db, storage } from "@/firebase";
import {
  // query,
  // where,
  collection,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
  // documentId
} from "firebase/firestore/lite";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";

export default {
  components: {
    cropperDialogs,
  },
  data: () => ({
    valid: true,
    dialog_showUploadImg: false,
    boilerplate: true,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "活動名稱",
        align: "start",
        sortable: false,
        value: "storeName",
      },
      {
        text: "啟用",
        value: "shouldDisplay",
        align: "center",
        sortable: false,
        width: "6%",
      },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "刪除",
        value: "actionsDel",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "展開",
        value: "data-table-expand",
        sortable: false,
        align: "center",
        width: "6%",
      },
    ],
    desserts: [],
    editedIndex: -1,
    defaultItem: { shouldDisplay: false, photoUrl: "", storeName: "" },
    template: { shouldDisplay: false, photoUrl: "", storeName: "" },
    transitioned: [],
    closeTimeouts: {},
    photoFile: null,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  created() {
    this.$bus.$emit("sideBarSelectedItem:push", 10);
    this.getTopBannerAds();
  },

  methods: {
    showUploadImg() {
      this.dialog_showUploadImg = true;
    },
    getImgFile(file) {
      fetch(file)
        .then((res) => res.blob())
        .then((res) => {
          this.template.photoUrl = URL.createObjectURL(res);
          this.photoFile = res;
          this.dialog_showUploadImg = false;
          console.log(res);
        });
    },
    async getTopBannerAds() {
      const querySnapshot = await getDocs(collection(db, "topBannerAds"));
      querySnapshot.forEach((doc) => {
        // let data;
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data());
        // data = JSON.parse(JSON.stringify(doc.data()));
        // data.id = doc.id;
        this.desserts.push(doc.data());
        // this.desserts.sort((a, b) => {
        //   return a.cityId - b.cityId;
        // });
      });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      // this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
      // const q = query(
      //   collection(db, "topBannerImages"),
      //   where(documentId(), "==", this.template.id)
      // );
      // const querySnapshot = await getDocs(q);
      await deleteDoc(doc(db, "topBannerAds", this.template.id));
      this.$snackbar.add(`刪除成功`, { color: "success" });
      this.desserts = [];
      this.getTopBannerAds();
      this.dialogDelete = false;
    },
    close() {
      this.photoFile = null;
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf("/") - 1) >>> 0) + 2);
    },
    onFileChange(event) {
      let files = event;
      if (JSON.stringify(files) !== "{}") return;
      if (Math.round(files.size, (Math / 1024) * 100) / 1000000 > 5) {
        alert("圖檔尺寸大於5MB，請壓縮後重新上傳");
        return;
      }
      if (this.photoFile && this.dialog) {
        this.template.photoUrl = URL.createObjectURL(this.photoFile);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          // Object.assign(this.desserts[this.editedIndex], this.template);
          if (this.photoFile) {
            let fileName = `photoFile.${this.getFileExtension(
              this.photoFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/topBannerImages/${this.template.id}/${fileName}`),
              this.photoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(storage, `/topBannerImages/${this.template.id}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.photoUrl = url;
              });
            });
          }
          let data = this.template;
          if (this.template.linkUrl) {
            data.linkUrl = this.template.linkUrl;
          } else {
            data.linkUrl = "";
          }
          await setDoc(doc(db, "topBannerAds", this.template.id), data);
        } else {
          let createdId = doc(collection(db, "env")).id;
          if (this.photoFile) {
            let fileName = `photoFile.${this.getFileExtension(
              this.photoFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/topBannerImages/${createdId}/${fileName}`),
              this.photoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(storage, `/topBannerImages/${createdId}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.photoUrl = url;
              });
            });
          }
          let data = this.template;
          if (this.template.linkUrl) {
            data.linkUrl = this.template.linkUrl;
          } else {
            data.linkUrl = "";
          }
          data.id = createdId;
          await setDoc(doc(db, "topBannerAds", createdId), data);
        }
        this.photoFile = null;
        this.desserts = [];
        this.getTopBannerAds();
        this.$snackbar.add(`修改完成`, { color: "success" });
        this.close();
      }
    },
    getItemId(item) {
      return item.storeName; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    previewImage(item) {
      this.stylePreviewImage = {
        "background-image": `url(${item.pictureArray[0].src})`,
      };
      this.isOpenPreviewImage = true;
    },
  },
};
</script>
<style></style>
